module.exports = __webpack_public_path__ + "static/media/dragon-two.4ac9a6cf.png";